import React from 'react'
import { Grid, Icon, Image } from 'semantic-ui-react';
import Labels from './../../../../common/Labels';
import _ from 'lodash';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import MomentDateAndTime from './../../../../../helpers/momentDateAndTime'
import EllipsisTooltip from '../../../../common/EllipsisTooltip'

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Details Card');
    }
})
class Summary extends React.Component {

    render() {

        const { selectedContent } = this.props;

        return (
            <Grid  >
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Labels
                            name="Name"
                            text={selectedContent.name} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Labels
                            name="Type"
                            text={selectedContent.type} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Labels
                            name="Publishing Level"
                            text={selectedContent.scope === "Private" ? "Workspace Library" : "Public Library"} />
                    </Grid.Column>

                    <Grid.Column width={8}>
                        <Labels
                            name="Created On"
                            text={MomentDateAndTime(selectedContent.createdAt)} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <Labels
                            name="Last Updated"
                            text={MomentDateAndTime(selectedContent.updatedAt)} />
                    </Grid.Column>
                    <Grid.Column width={16}>
                        {selectedContent && selectedContent.baseCategory &&
                            <Labels
                                name="Category"
                                text={<span>
                                    <EllipsisTooltip
                                        name={selectedContent.baseCategory.name ? selectedContent.baseCategory.name : selectedContent.baseCategory}
                                        className="float-left" />
                                    <Icon name="chevron right" style={{ margin: "0px 5px 0px 7px" }} className="float-left" />
                                    <EllipsisTooltip
                                        name={selectedContent.category.name ? selectedContent.category.name : selectedContent.category}
                                        className="float-left" />
                                    <Icon name="chevron right" style={{ margin: "0px 5px 0px 7px" }} className="float-left" />
                                    <EllipsisTooltip
                                        name={selectedContent.subCategory.name ? selectedContent.subCategory.name : selectedContent.subCategory}
                                        className="float-left" />
                                </span>

                                } />}
                    </Grid.Column>
                    {selectedContent.authorObj ?
                        <Grid.Column width={16}>
                            <Labels
                                name="Owner"
                                text={<span>
                                    <Image avatar className="w_24 h_24 float-left" src={selectedContent.authorObj.profilePic} />
                                    <b style={{ padding: "3px 0 0 0", display: "block" }}>
                                        {selectedContent.authorObj.firstName}&nbsp;
                                        {selectedContent.authorObj.lastName}
                                    </b>
                                </span>
                                } />
                        </Grid.Column> : null
                    }

                    {selectedContent.author && selectedContent.author._id ?
                        <Grid.Column width={16}>
                            <Labels
                                name="Owner"
                                text={<span>
                                    <Image avatar className="w_24 h_24 float-left" src={selectedContent.author.profilePic} />
                                    <b style={{ padding: "3px 0 0 0", display: "block" }}>
                                        {selectedContent.author.firstName}&nbsp;
                                        {selectedContent.author.lastName}
                                    </b>
                                </span>
                                } />
                        </Grid.Column> : null
                    }

                    {!_.isEmpty(selectedContent.reviewedbyObj) ?
                        <Grid.Column width={16}>
                            <Labels
                                name="Reviewer "
                                text={selectedContent.reviewedbyObj ?
                                    <span>
                                        <Image avatar className="w_24 h_24 float-left" src={selectedContent.reviewedbyObj.profilePic} />
                                        <b style={{ padding: "3px 0 0 0", display: "block" }}>
                                            {selectedContent.reviewedbyObj.firstName}&nbsp;
                                        {selectedContent.reviewedbyObj.lastName}
                                        </b>
                                    </span>
                                    : null} />
                        </Grid.Column> : null
                    }
                </Grid.Row>
            </Grid >
        )
    }
}

export default Summary


// (selectedContent.baseCategory || selectedContent.category || selectedContent.subCategory) === "" ?
//                                     <span >NA</span>
//                                     :
//                                     <span >
//                                         {selectedContent.baseCategory && selectedContent.baseCategory.name} &nbsp; <Icon name="chevron right" />
//                                         {selectedContent.category && selectedContent.category.name}&nbsp;<Icon name="chevron right" />
//                                         {selectedContent.subCategory && selectedContent.subCategory.name}
//                                     </span>